import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=a590353a&scoped=true"
import script from "./ShopView.vue?vue&type=script&lang=js"
export * from "./ShopView.vue?vue&type=script&lang=js"
import style0 from "./ShopView.vue?vue&type=style&index=0&id=a590353a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a590353a",
  null
  
)

export default component.exports